import axios from 'axios'
import {
  GET_MEMBERSHIP_BENIFITS,
  GET_MEMBERSHIP_PLAN_AND_PATIENT_DETAILS,
} from '../utils/Endpoints'

export const getMembershipDetails = async (
  muhId: string,
  membershipType: string
) => {
  try {
    const response: any = await axios.get(
      `${process.env.REACT_APP_ODOO_URL}/membership/lines?partner=${muhId}&mbr_type=${membershipType}`,
      {
        headers: {
          'api-key': process.env.REACT_APP_ODOO_API_KEY || '',
        },
      }
    )
    const { data } = response?.data || {}
    if (data) {
      return {
        success: true,
        data: data,
        message: 'Data Fetched Successfully',
      }
    } else {
      return {
        success: false,
        data: null,
        message: 'Failed to Fetch Data',
      }
    }
  } catch (error: any) {
    console.error('Error: ', error)
    return {
      success: false,
      data: null,
      message: error?.message,
    }
  }
}

export const getMembershipBenifits = async (id: string) => {
  try {
    const response: any = await axios.get(
      `${process.env.REACT_APP_ODOO_URL}${GET_MEMBERSHIP_BENIFITS}${id}`,
      {
        headers: {
          'api-key': process.env.REACT_APP_ODOO_API_KEY || '',
        },
      }
    )
    if (response?.data) {
      return {
        success: true,
        data: response?.data,
        message: 'Data Fetched Successfully',
      }
    } else {
      return {
        success: false,
        data: null,
        message: 'Failed to Fetch Data',
      }
    }
  } catch (error: any) {
    console.error('Error: ', error)
    return {
      success: false,
      data: null,
      message: error?.message,
    }
  }
}

export const getMemberPlanAndPatientDetails = async (lineId: string) => {
  try {
    const response: any = await axios.get(
      `${process.env.REACT_APP_ODOO_URL}${GET_MEMBERSHIP_PLAN_AND_PATIENT_DETAILS}${lineId}`,
      {
        headers: {
          'api-key': process.env.REACT_APP_ODOO_API_KEY || '',
        },
      }
    )
    if (response?.data) {
      return {
        success: true,
        data: response?.data,
        message: 'Data Fetched Successfully',
      }
    } else {
      return {
        success: false,
        data: null,
        message: 'Failed to Fetch Data',
      }
    }
  } catch (error: any) {
    console.error('Error: ', error)
    return {
      success: false,
      data: null,
      message: error?.message,
    }
  }
}
